import { Injectable } from '@angular/core';
import { ApplicationModel } from '@ups/xplat/api/dto';
import { HRResourceService } from './hrresource-service';

@Injectable({
  providedIn: 'root',
})
export class BackgroundTeamResolver {
  constructor(
    private hrResourceService: HRResourceService,
    private applicationModel: ApplicationModel
  ) {}

  resolve(): Promise<unknown> | null {
    if (this.applicationModel.backgroundTeam.length === 0) {
      return this.hrResourceService
        .fetchBackgroundTeam()
        .then((data) => (this.applicationModel.backgroundTeam = data));
    }

    return null;
  }
}
